// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".breadcrmbs-background[data-v-b78242a0]{background:linear-gradient(90deg,hsla(0,0%,100%,0),hsla(0,0%,100%,.2) 60%,#fff 110%)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
